import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoComponentV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoComponentV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";

/** Dto de stockage des inforamtions qui seront transferées du client au serveur
Pour la réorganisation de lignes. */
export interface IIsiDtoReorgUI extends IIsiDataTransferObject  {
    /** Identifiant du context de grille associé */
    contextId?: string;
    /** Liste des entitées concernées. */
    rows?: IIsiDtoGridRows;
    /** Type de mouvement monter descendre en premier en dernier. */
    moveType?: MoveType;
}
/** Représente une collection de ligne dans la grille */
export interface IIsiDtoGridRows extends IIsiDataTransferObject  {
    all?: IIsiDtoGridRow[];
}
/** Représente une ligne de la grille */
export interface IIsiDtoGridRow extends IIsiDataTransferObject  {
    cells?: IIsiDtoGridCells;
}
/** Représente une collection de cellules dans la grille */
export interface IIsiDtoGridCells extends IIsiDataTransferObject  {
    all?: IIsiDtoGridCell[];
}
export interface IIsiDtoGridCell extends IIsiDataTransferObject  {
    /** Obtient ou définie la valeur de la cellule */
    value?: any;
    /** Obtient ou définie la clé de la cellule (identifiant de la colonne) */
    key?: string;
}
/** Une cellule de la grille */
export class IsiDtoGridCell extends IsiDataTransferObject implements IIsiDtoGridCell {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.Grid.IsiDtoGridCell, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définie la valeur de la cellule */
    value?: any;
    /** Obtient ou définie la clé de la cellule (identifiant de la colonne) */
    key?: string;

    constructor(data?: IIsiDtoGridCell) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridCell): IsiDtoGridCell {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Collection de cellules */
export class IsiDtoGridCells extends IsiDataTransferObject implements IIsiDtoGridCells {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.Grid.IsiDtoGridCells, Isilog.IsiFramework.IsiDataTransferObject";
    all?: IsiDtoGridCell[];

    constructor(data?: IIsiDtoGridCells) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.all = _data["all"] !== undefined ? _data["all"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridCells): IsiDtoGridCells {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridCells();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["all"] = this.all !== undefined ? this.all : [];
        return data;
    }
}
/** Une ligne de la grille */
export class IsiDtoGridRow extends IsiDataTransferObject implements IIsiDtoGridRow {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.Grid.IsiDtoGridRow, Isilog.IsiFramework.IsiDataTransferObject";
    cells?: IsiDtoGridCells;

    constructor(data?: IIsiDtoGridRow) {
        super(data);
        if (data) {
            this.cells = data.cells && !(<any>data.cells).toJSON ? new IsiDtoGridCells(data.cells) : <IsiDtoGridCells>this.cells;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cells = _data["cells"] ? IsiDtoGridCells.fromJS(_data["cells"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridRow): IsiDtoGridRow {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["cells"] = this.cells != null ? (<any>this.cells).toJSON() : <any>null;
        return data;
    }
}
/** Collection de ligne dans la grille */
export class IsiDtoGridRows extends IsiDataTransferObject implements IIsiDtoGridRows {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.Grid.IsiDtoGridRows, Isilog.IsiFramework.IsiDataTransferObject";
    all?: IsiDtoGridRow[];

    constructor(data?: IIsiDtoGridRows) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.all = _data["all"] !== undefined ? _data["all"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridRows): IsiDtoGridRows {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["all"] = this.all !== undefined ? this.all : [];
        return data;
    }
}
export enum MoveType {
    First = 0,
    Up = 1,
    Down = 2,
    Last = 3,
}
/** Dto du service de réorganisation de lignes. */
export class IsiDtoReorgUI extends IsiDataTransferObject implements IIsiDtoReorgUI {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.Reorganization.IsiDtoReorgUI, Isilog.IsiFramework.IsiDataTransferObject";
    /** Identifiant du context de grille associé */
    contextId?: string;
    /** Liste des entitées concernées. */
    rows?: IsiDtoGridRows;
    /** Type de mouvement monter descendre en premier en dernier. */
    moveType?: MoveType;

    constructor(data?: IIsiDtoReorgUI) {
        super(data);
        if (data) {
            this.rows = data.rows && !(<any>data.rows).toJSON ? new IsiDtoGridRows(data.rows) : <IsiDtoGridRows>this.rows;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contextId = _data["contextId"] !== undefined ? _data["contextId"] : <any>null;
            this.rows = _data["rows"] ? IsiDtoGridRows.fromJS(_data["rows"]) : <any>null;
            this.moveType = _data["moveType"] !== undefined ? _data["moveType"] : MoveType.First;
        }
    }

    static fromJS(data?: IIsiDtoReorgUI): IsiDtoReorgUI {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoReorgUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["contextId"] = this.contextId !== undefined ? this.contextId : <any>null;
        data["rows"] = this.rows != null ? (<any>this.rows).toJSON() : <any>null;
        data["moveType"] = this.moveType !== undefined ? this.moveType : MoveType.First;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewClientState extends IIsiDtoComponentClientState  {
    /** Indique si tous les groupement on été supprimé côté client */
    allGrpRemoved?: boolean;
    /** Contient le modification effectuées sur les colonnes par l'utilisateur par rapport à la configuration en base */
    columnsState?: { [key: string]: IIsiDtoGridViewColumnClientState; };
    activeRow?: IIsiDtoGridViewSelectedRowClientState;
    selectedRows?: IIsiDtoGridViewSelectedRowsClientState;
    gridViewId?: string;
    /** Filtre de recherche rapide */
    gridViewFilter?: string;
    allLinesSelected?: boolean;
    gridState?: IIsiDtoGridClientState;
}
/** Etat des modifications cliente des colonnes */
export interface IIsiDtoGridViewColumnClientState extends IIsiDataTransferObject  {
    /** Indique Le tri y compris si la colonne a été groupée */
    sorting?: string;
    /** Si != -1 la colonne est groupée */
    grpIndex?: number;
}
export class IsiDtoGridViewColumnClientState extends IsiDataTransferObject implements IIsiDtoGridViewColumnClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewColumnClientState, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique Le tri y compris si la colonne a été groupée */
    sorting?: string;
    /** Si != -1 la colonne est groupée */
    grpIndex?: number;

    constructor(data?: IIsiDtoGridViewColumnClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : <any>null;
            this.grpIndex = _data["grpIndex"] !== undefined ? _data["grpIndex"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGridViewColumnClientState): IsiDtoGridViewColumnClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewColumnClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sorting"] = this.sorting !== undefined ? this.sorting : <any>null;
        data["grpIndex"] = this.grpIndex !== undefined ? this.grpIndex : 0;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewSelectedRowClientState extends IIsiDataTransferObject  {
    datas?: { [key: string]: any; };
    realKey?: { [key: string]: string; };
    key?: string;
}
export class IsiDtoGridViewSelectedRowClientState extends IsiDataTransferObject implements IIsiDtoGridViewSelectedRowClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewSelectedRowClientState, Isilog.IsiFramework.IsiDataTransferObject";
    datas?: { [key: string]: any; };
    realKey?: { [key: string]: string; };
    key?: string;

    constructor(data?: IIsiDtoGridViewSelectedRowClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datas = _data["datas"] !== undefined ? _data["datas"] : <any>null;
            this.realKey = _data["realKey"];
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridViewSelectedRowClientState): IsiDtoGridViewSelectedRowClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewSelectedRowClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["datas"] = this.datas !== undefined ? this.datas : <any>null;
        data["realKey"] = this.realKey !== undefined ? this.realKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewSelectedRowsClientState extends IIsiDataTransferObject  {
    rows?: IIsiDtoGridViewSelectedRowClientState[];
}
export class IsiDtoGridViewSelectedRowsClientState extends IsiDataTransferObject implements IIsiDtoGridViewSelectedRowsClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewSelectedRowsClientState, Isilog.IsiFramework.IsiDataTransferObject";
    rows?: IIsiDtoGridViewSelectedRowClientState[];

    constructor(data?: IIsiDtoGridViewSelectedRowsClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rows = _data["rows"];
        }
    }

    static fromJS(data?: IIsiDtoGridViewSelectedRowsClientState): IsiDtoGridViewSelectedRowsClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewSelectedRowsClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["rows"] = this.rows !== undefined ? this.rows : [];
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridClientState extends IIsiDtoComponentClientState  {
    features?: IIsiDtoGridFeaturesClientState;
    columns?: IIsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IIsiDtoGridSelectedRow;
    selectedRows?: IIsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;
}
export interface IIsiDtoGridFeaturesClientState extends IIsiDataTransferObject  {
    sorting?: IIsiDtoGridSortingFeatureClientState;
    filtering?: IIsiDtoGridFilteringFeatureClientState;
}
export interface IIsiDtoGridSortingFeatureClientState extends IIsiDataTransferObject  {
    columnSettings?: any[];
}
export class IsiDtoGridSortingFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridSortingFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSortingFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    columnSettings?: any[];

    constructor(data?: IIsiDtoGridSortingFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnSettings = _data["columnSettings"];
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureClientState): IsiDtoGridSortingFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        return data;
    }
}
export interface IIsiDtoGridFilteringFeatureClientState extends IIsiDataTransferObject  {
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];
}
export class IsiDtoGridFilteringFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridFilteringFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFilteringFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];

    constructor(data?: IIsiDtoGridFilteringFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.globalFilterValue = _data["globalFilterValue"] !== undefined ? _data["globalFilterValue"] : <any>null;
            this.columnSettings = _data["columnSettings"];
            this.filtersByColumn = _data["filtersByColumn"];
            this.filters = _data["filters"];
        }
    }

    static fromJS(data?: IIsiDtoGridFilteringFeatureClientState): IsiDtoGridFilteringFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFilteringFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["globalFilterValue"] = this.globalFilterValue !== undefined ? this.globalFilterValue : <any>null;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        data["filtersByColumn"] = this.filtersByColumn !== undefined ? this.filtersByColumn : [];
        data["filters"] = this.filters !== undefined ? this.filters : [];
        return data;
    }
}
export class IsiDtoGridFeaturesClientState extends IsiDataTransferObject implements IIsiDtoGridFeaturesClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFeaturesClientState, Isilog.IsiFramework.IsiDataTransferObject";
    sorting?: IsiDtoGridSortingFeatureClientState;
    filtering?: IsiDtoGridFilteringFeatureClientState;

    constructor(data?: IIsiDtoGridFeaturesClientState) {
        super(data);
        if (data) {
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureClientState(data.sorting) : <IsiDtoGridSortingFeatureClientState>this.sorting;
            this.filtering = data.filtering && !(<any>data.filtering).toJSON ? new IsiDtoGridFilteringFeatureClientState(data.filtering) : <IsiDtoGridFilteringFeatureClientState>this.filtering;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureClientState.fromJS(_data["sorting"]) : <any>null;
            this.filtering = _data["filtering"] ? IsiDtoGridFilteringFeatureClientState.fromJS(_data["filtering"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridFeaturesClientState): IsiDtoGridFeaturesClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFeaturesClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["filtering"] = this.filtering != null ? (<any>this.filtering).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoGridColumn extends IIsiDataTransferObject  {
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IIsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IIsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;
}
export enum TypeAggregation {
    Text = 0,
    Somme = 1,
    Moyenne = 2,
    Minimum = 3,
    Maximum = 4,
    Count = 5,
    None = 6,
}
export enum TypeCtrl {
    None = 0,
    MultilineText = 1,
    Connexe = 2,
    Others = -1,
}
export enum CtrlFormat {
    None = 0,
    Text = 1,
    Numerical = 2,
    Price = 3,
    Amount = 4,
    Boolean = 5,
    Date = 6,
    Hour = 7,
    DateHour = 8,
    RichText = 9,
}
export enum EscapeType {
    None = 0,
    Encode = 1,
    Sanitarize = 2,
}
/** Les types de rendu possibles pour une colonne. */
export enum ColumnRenderTypes {
    Custom = 0,
    Boolean = 1,
    Checkbox = 2,
}
export interface IIsiDtoGridColumnSettings extends IIsiDataTransferObject  {
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridUpdatingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridColumnSettings extends IsiDataTransferObject implements IIsiDtoGridColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridColumnSettings): IsiDtoGridColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridUpdatingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridUpdatingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridUpdatingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;

    constructor(data?: IIsiDtoGridUpdatingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : false;
            this.req = _data["req"] !== undefined ? _data["req"] : false;
            this.eT = _data["eT"] !== undefined ? _data["eT"] : "text";
            this.edVK = _data["edVK"] !== undefined ? _data["edVK"] : <any>null;
            this.edTK = _data["edTK"] !== undefined ? _data["edTK"] : <any>null;
            this.edUrl = _data["edUrl"] !== undefined ? _data["edUrl"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridUpdatingFeatureColumnSettings): IsiDtoGridUpdatingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridUpdatingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : false;
        data["req"] = this.req !== undefined ? this.req : false;
        data["eT"] = this.eT !== undefined ? this.eT : "text";
        data["edVK"] = this.edVK !== undefined ? this.edVK : <any>null;
        data["edTK"] = this.edTK !== undefined ? this.edTK : <any>null;
        data["edUrl"] = this.edUrl !== undefined ? this.edUrl : <any>null;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridSortingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    direction?: string;
    allowSorting?: boolean;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridSortingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridSortingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridSortingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    direction?: string;
    allowSorting?: boolean;

    constructor(data?: IIsiDtoGridSortingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.direction = _data["direction"] !== undefined ? _data["direction"] : "False";
            this.allowSorting = _data["allowSorting"] !== undefined ? _data["allowSorting"] : true;
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureColumnSettings): IsiDtoGridSortingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["direction"] = this.direction !== undefined ? this.direction : "False";
        data["allowSorting"] = this.allowSorting !== undefined ? this.allowSorting : true;
        return data;
    }
}
export class IsiDtoGridColumn extends IsiDataTransferObject implements IIsiDtoGridColumn {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridColumn, Isilog.IsiFramework.IsiDataTransferObject";
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;

    constructor(data?: IIsiDtoGridColumn) {
        super(data);
        if (data) {
            this.updating = data.updating && !(<any>data.updating).toJSON ? new IsiDtoGridUpdatingFeatureColumnSettings(data.updating) : <IsiDtoGridUpdatingFeatureColumnSettings>this.updating;
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureColumnSettings(data.sorting) : <IsiDtoGridSortingFeatureColumnSettings>this.sorting;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.headerTooltip = _data["headerTooltip"] !== undefined ? _data["headerTooltip"] : <any>null;
            this.typeAggreg = _data["typeAggreg"] !== undefined ? _data["typeAggreg"] : TypeAggregation.Text;
            this.columnIndex = _data["columnIndex"] !== undefined ? _data["columnIndex"] : 0;
            this.allowTooltips = _data["allowTooltips"] !== undefined ? _data["allowTooltips"] : false;
            this.columnRacc = _data["columnRacc"] !== undefined ? _data["columnRacc"] : <any>null;
            this.associateFormCtrlType = _data["associateFormCtrlType"] !== undefined ? _data["associateFormCtrlType"] : TypeCtrl.None;
            this.alignRight = _data["alignRight"] !== undefined ? _data["alignRight"] : false;
            this.ctrlFormat = _data["ctrlFormat"] !== undefined ? _data["ctrlFormat"] : CtrlFormat.None;
            this.fieldLength = _data["fieldLength"] !== undefined ? _data["fieldLength"] : 0;
            this.dataSourceId = _data["dataSourceId"] !== undefined ? _data["dataSourceId"] : <any>null;
            this.escapeHtml = _data["escapeHtml"] !== undefined ? _data["escapeHtml"] : EscapeType.None;
            this.unbound = _data["unbound"] !== undefined ? _data["unbound"] : false;
            this.formula = _data["formula"] !== undefined ? _data["formula"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.renderType = _data["renderType"] !== undefined ? _data["renderType"] : ColumnRenderTypes.Custom;
            this.formatter = _data["formatter"] !== undefined ? _data["formatter"] : <any>null;
            this.columnCssClass = _data["columnCssClass"] !== undefined ? _data["columnCssClass"] : <any>null;
            this.headerCssClass = _data["headerCssClass"] !== undefined ? _data["headerCssClass"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.textColumnKey = _data["textColumnKey"] !== undefined ? _data["textColumnKey"] : <any>null;
            this.updating = _data["updating"] ? IsiDtoGridUpdatingFeatureColumnSettings.fromJS(_data["updating"]) : <any>null;
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureColumnSettings.fromJS(_data["sorting"]) : <any>null;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : false;
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : <any>null;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridColumn): IsiDtoGridColumn {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["headerTooltip"] = this.headerTooltip !== undefined ? this.headerTooltip : <any>null;
        data["typeAggreg"] = this.typeAggreg !== undefined ? this.typeAggreg : TypeAggregation.Text;
        data["columnIndex"] = this.columnIndex !== undefined ? this.columnIndex : 0;
        data["allowTooltips"] = this.allowTooltips !== undefined ? this.allowTooltips : false;
        data["columnRacc"] = this.columnRacc !== undefined ? this.columnRacc : <any>null;
        data["associateFormCtrlType"] = this.associateFormCtrlType !== undefined ? this.associateFormCtrlType : TypeCtrl.None;
        data["alignRight"] = this.alignRight !== undefined ? this.alignRight : false;
        data["ctrlFormat"] = this.ctrlFormat !== undefined ? this.ctrlFormat : CtrlFormat.None;
        data["fieldLength"] = this.fieldLength !== undefined ? this.fieldLength : 0;
        data["dataSourceId"] = this.dataSourceId !== undefined ? this.dataSourceId : <any>null;
        data["escapeHtml"] = this.escapeHtml !== undefined ? this.escapeHtml : EscapeType.None;
        data["unbound"] = this.unbound !== undefined ? this.unbound : false;
        data["formula"] = this.formula !== undefined ? this.formula : <any>null;
        data["id"] = this.id !== undefined ? this.id : 0;
        data["renderType"] = this.renderType !== undefined ? this.renderType : ColumnRenderTypes.Custom;
        data["formatter"] = this.formatter !== undefined ? this.formatter : <any>null;
        data["columnCssClass"] = this.columnCssClass !== undefined ? this.columnCssClass : <any>null;
        data["headerCssClass"] = this.headerCssClass !== undefined ? this.headerCssClass : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["textColumnKey"] = this.textColumnKey !== undefined ? this.textColumnKey : <any>null;
        data["updating"] = this.updating != null ? (<any>this.updating).toJSON() : <any>null;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["hidden"] = this.hidden !== undefined ? this.hidden : false;
        data["headerText"] = this.headerText !== undefined ? this.headerText : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridSelectedRow extends IIsiDataTransferObject  {
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridSelectedRow extends IsiDataTransferObject implements IIsiDtoGridSelectedRow {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSelectedRow, Isilog.IsiFramework.IsiDataTransferObject";
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;

    constructor(data?: IIsiDtoGridSelectedRow) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datas = _data["datas"];
            this.realKey = _data["realKey"];
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridSelectedRow): IsiDtoGridSelectedRow {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSelectedRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["datas"] = this.datas !== undefined ? this.datas : <any>null;
        data["realKey"] = this.realKey !== undefined ? this.realKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridClientState extends IsiDtoComponentClientState implements IIsiDtoGridClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridClientState, Isilog.IsiFramework.IsiDataTransferObject";
    features?: IsiDtoGridFeaturesClientState;
    columns?: IsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IsiDtoGridSelectedRow;
    selectedRows?: IsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;

    constructor(data?: IIsiDtoGridClientState) {
        super(data);
        if (data) {
            this.features = data.features && !(<any>data.features).toJSON ? new IsiDtoGridFeaturesClientState(data.features) : <IsiDtoGridFeaturesClientState>this.features;
            this.activeRow = data.activeRow && !(<any>data.activeRow).toJSON ? new IsiDtoGridSelectedRow(data.activeRow) : <IsiDtoGridSelectedRow>this.activeRow;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.features = _data["features"] ? IsiDtoGridFeaturesClientState.fromJS(_data["features"]) : <any>null;
            this.columns = _data["columns"] !== undefined ? _data["columns"] : [];
            this.data = _data["data"];
            this.totalLocalRecordsCount = _data["totalLocalRecordsCount"] !== undefined ? _data["totalLocalRecordsCount"] : 0;
            this.totalRecordCount = _data["totalRecordCount"] !== undefined ? _data["totalRecordCount"] : 0;
            this.scrollTop = _data["scrollTop"] !== undefined ? _data["scrollTop"] : 0;
            this.activeRow = _data["activeRow"] ? IsiDtoGridSelectedRow.fromJS(_data["activeRow"]) : <any>null;
            this.selectedRows = _data["selectedRows"] !== undefined ? _data["selectedRows"] : [];
            this.allLinesSelected = _data["allLinesSelected"] !== undefined ? _data["allLinesSelected"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridClientState): IsiDtoGridClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["features"] = this.features != null ? (<any>this.features).toJSON() : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        data["data"] = this.data !== undefined ? this.data : [];
        data["totalLocalRecordsCount"] = this.totalLocalRecordsCount !== undefined ? this.totalLocalRecordsCount : 0;
        data["totalRecordCount"] = this.totalRecordCount !== undefined ? this.totalRecordCount : 0;
        data["scrollTop"] = this.scrollTop !== undefined ? this.scrollTop : 0;
        data["activeRow"] = this.activeRow != null ? (<any>this.activeRow).toJSON() : <any>null;
        data["selectedRows"] = this.selectedRows !== undefined ? this.selectedRows : [];
        data["allLinesSelected"] = this.allLinesSelected !== undefined ? this.allLinesSelected : false;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridViewClientState extends IsiDtoComponentClientState implements IIsiDtoGridViewClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewClientState, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique si tous les groupement on été supprimé côté client */
    allGrpRemoved?: boolean;
    /** Contient le modification effectuées sur les colonnes par l'utilisateur par rapport à la configuration en base */
    columnsState?: { [key: string]: IsiDtoGridViewColumnClientState; };
    activeRow?: IsiDtoGridViewSelectedRowClientState;
    selectedRows!: IsiDtoGridViewSelectedRowsClientState;
    gridViewId?: string;
    /** Filtre de recherche rapide */
    gridViewFilter?: string;
    allLinesSelected?: boolean;
    gridState?: IsiDtoGridClientState;

    constructor(data?: IIsiDtoGridViewClientState) {
        super(data);
        if (data) {
            this.activeRow = data.activeRow && !(<any>data.activeRow).toJSON ? new IsiDtoGridViewSelectedRowClientState(data.activeRow) : <IsiDtoGridViewSelectedRowClientState>this.activeRow;
            this.selectedRows = data.selectedRows && !(<any>data.selectedRows).toJSON ? new IsiDtoGridViewSelectedRowsClientState(data.selectedRows) : <IsiDtoGridViewSelectedRowsClientState>this.selectedRows;
            this.gridState = data.gridState && !(<any>data.gridState).toJSON ? new IsiDtoGridClientState(data.gridState) : <IsiDtoGridClientState>this.gridState;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allGrpRemoved = _data["allGrpRemoved"] !== undefined ? _data["allGrpRemoved"] : false;
            this.columnsState = _data["columnsState"] !== undefined ? _data["columnsState"] : <any>null;
            this.activeRow = _data["activeRow"] ? IsiDtoGridViewSelectedRowClientState.fromJS(_data["activeRow"]) : <any>null;
            this.selectedRows = IsiDtoGridViewSelectedRowsClientState.fromJS(_data["selectedRows"]);
            this.gridViewId = _data["gridViewId"] !== undefined ? _data["gridViewId"] : <any>null;
            this.gridViewFilter = _data["gridViewFilter"] !== undefined ? _data["gridViewFilter"] : <any>null;
            this.allLinesSelected = _data["allLinesSelected"] !== undefined ? _data["allLinesSelected"] : false;
            this.gridState = _data["gridState"] ? IsiDtoGridClientState.fromJS(_data["gridState"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridViewClientState): IsiDtoGridViewClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["allGrpRemoved"] = this.allGrpRemoved !== undefined ? this.allGrpRemoved : false;
        data["columnsState"] = this.columnsState !== undefined ? this.columnsState : <any>null;
        data["activeRow"] = this.activeRow != null ? (<any>this.activeRow).toJSON() : <any>null;
        data["selectedRows"] = this.selectedRows.toJSON();
        data["gridViewId"] = this.gridViewId !== undefined ? this.gridViewId : <any>null;
        data["gridViewFilter"] = this.gridViewFilter !== undefined ? this.gridViewFilter : <any>null;
        data["allLinesSelected"] = this.allLinesSelected !== undefined ? this.allLinesSelected : false;
        data["gridState"] = this.gridState != null ? (<any>this.gridState).toJSON() : <any>null;
        return data;
    }
}
/** Représente l'état du composant IIsiAssociatedView coté client */
export interface IIsiDtoAssociatedViewClientState extends IIsiDtoGridViewClientState  {
}
/** Représente l'état de la grille coté client */
export class IsiDtoAssociatedViewClientState extends IsiDtoGridViewClientState implements IIsiDtoAssociatedViewClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.AssociatedView.IsiDtoAssociatedViewClientState, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoAssociatedViewClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoAssociatedViewClientState): IsiDtoAssociatedViewClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAssociatedViewClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoGridView extends IIsiDtoComponentV4  {
    /** Indique si on force le rendu en mode tablette */
    forceTabletRenderMode?: boolean;
    /** Liste des colonnes pour lesquelles on n'affiche pas de tooltips dans le header en mode carte */
    blacklistTooltipColumnHeaderCardMode?: string[];
    /** Mode utilisé pour l'affichage de la grille */
    gridViewMode?: GridViewRenderMode;
    /** Indique si le composant IsiMoreButton doit être chargé. */
    needMoreButton?: boolean;
    /** Indique si notamment les colonnes sont chargées que sur le firstload du gridview. */
    lazyLoad?: boolean;
    /** id du composant burger menu */
    bgmCmpId?: string;
    /** Identifiant de la consigne contenant les informations à passé au détail pour son chargement */
    lockerId?: string;
    /** Indique si le grid view autorise la modification 
/!\ il faudra quand même paramétrer chaque colonne modifiable */
    updatable?: boolean;
    groups?: string[];
    /** Indique si la pagination est active ou non */
    isPaginationEnabled?: boolean;
    chunkSize?: number;
    /** Liste des colonnes qui ne peuvent pas être utilisé comme colonne identifiant (dans le cas où la première colonne est considéré comme la colonne identifiant) */
    listColumnKeyForbiddenId?: string[];
    /** Liste des colonnes qui doivent être placé en première en mode carte et smartphone */
    listColumnKeyPrority?: string[];
    screenListIdentCol?: string[];
    screenIdentCol?: string[];
    /** Identification de l'action graphique associé au double click */
    dblClickActionUIId?: string;
}
/** Mode d'affichage de la grille */
export enum GridViewRenderMode {
    Card = 1,
    Columns = 2,
}
/** La classe qui représente les données d'un composant IIsiTabularView */
export class IsiDtoGridView extends IsiDtoComponentV4 implements IIsiDtoGridView {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridView, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique si on force le rendu en mode tablette */
    forceTabletRenderMode?: boolean;
    /** Liste des colonnes pour lesquelles on n'affiche pas de tooltips dans le header en mode carte */
    blacklistTooltipColumnHeaderCardMode?: string[];
    /** Mode utilisé pour l'affichage de la grille */
    gridViewMode?: GridViewRenderMode;
    /** Indique si le composant IsiMoreButton doit être chargé. */
    needMoreButton?: boolean;
    /** Indique si notamment les colonnes sont chargées que sur le firstload du gridview. */
    lazyLoad?: boolean;
    /** id du composant burger menu */
    bgmCmpId?: string;
    /** Identifiant de la consigne contenant les informations à passé au détail pour son chargement */
    lockerId?: string;
    /** Indique si le grid view autorise la modification 
/!\ il faudra quand même paramétrer chaque colonne modifiable */
    updatable?: boolean;
    groups?: string[];
    /** Indique si la pagination est active ou non */
    isPaginationEnabled?: boolean;
    chunkSize?: number;
    /** Liste des colonnes qui ne peuvent pas être utilisé comme colonne identifiant (dans le cas où la première colonne est considéré comme la colonne identifiant) */
    listColumnKeyForbiddenId?: string[];
    /** Liste des colonnes qui doivent être placé en première en mode carte et smartphone */
    listColumnKeyPrority?: string[];
    screenListIdentCol?: string[];
    screenIdentCol?: string[];
    /** Identification de l'action graphique associé au double click */
    dblClickActionUIId?: string;

    constructor(data?: IIsiDtoGridView) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.forceTabletRenderMode = _data["forceTabletRenderMode"] !== undefined ? _data["forceTabletRenderMode"] : false;
            this.blacklistTooltipColumnHeaderCardMode = _data["blacklistTooltipColumnHeaderCardMode"];
            this.gridViewMode = _data["gridViewMode"] !== undefined ? _data["gridViewMode"] : GridViewRenderMode.Card;
            this.needMoreButton = _data["needMoreButton"] !== undefined ? _data["needMoreButton"] : false;
            this.lazyLoad = _data["lazyLoad"] !== undefined ? _data["lazyLoad"] : false;
            this.bgmCmpId = _data["bgmCmpId"] !== undefined ? _data["bgmCmpId"] : <any>null;
            this.lockerId = _data["lockerId"] !== undefined ? _data["lockerId"] : <any>null;
            this.updatable = _data["updatable"] !== undefined ? _data["updatable"] : false;
            this.groups = _data["groups"];
            this.isPaginationEnabled = _data["isPaginationEnabled"] !== undefined ? _data["isPaginationEnabled"] : false;
            this.chunkSize = _data["chunkSize"] !== undefined ? _data["chunkSize"] : 0;
            this.listColumnKeyForbiddenId = _data["listColumnKeyForbiddenId"];
            this.listColumnKeyPrority = _data["listColumnKeyPrority"];
            this.screenListIdentCol = _data["screenListIdentCol"];
            this.screenIdentCol = _data["screenIdentCol"];
            this.dblClickActionUIId = _data["dblClickActionUIId"] !== undefined ? _data["dblClickActionUIId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridView): IsiDtoGridView {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridView();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["forceTabletRenderMode"] = this.forceTabletRenderMode !== undefined ? this.forceTabletRenderMode : false;
        data["blacklistTooltipColumnHeaderCardMode"] = this.blacklistTooltipColumnHeaderCardMode !== undefined ? this.blacklistTooltipColumnHeaderCardMode : [];
        data["gridViewMode"] = this.gridViewMode !== undefined ? this.gridViewMode : GridViewRenderMode.Card;
        data["needMoreButton"] = this.needMoreButton !== undefined ? this.needMoreButton : false;
        data["lazyLoad"] = this.lazyLoad !== undefined ? this.lazyLoad : false;
        data["bgmCmpId"] = this.bgmCmpId !== undefined ? this.bgmCmpId : <any>null;
        data["lockerId"] = this.lockerId !== undefined ? this.lockerId : <any>null;
        data["updatable"] = this.updatable !== undefined ? this.updatable : false;
        data["groups"] = this.groups !== undefined ? this.groups : [];
        data["isPaginationEnabled"] = this.isPaginationEnabled !== undefined ? this.isPaginationEnabled : false;
        data["chunkSize"] = this.chunkSize !== undefined ? this.chunkSize : 0;
        data["listColumnKeyForbiddenId"] = this.listColumnKeyForbiddenId !== undefined ? this.listColumnKeyForbiddenId : [];
        data["listColumnKeyPrority"] = this.listColumnKeyPrority !== undefined ? this.listColumnKeyPrority : [];
        data["screenListIdentCol"] = this.screenListIdentCol !== undefined ? this.screenListIdentCol : [];
        data["screenIdentCol"] = this.screenIdentCol !== undefined ? this.screenIdentCol : [];
        data["dblClickActionUIId"] = this.dblClickActionUIId !== undefined ? this.dblClickActionUIId : <any>null;
        return data;
    }
}
/** Dto représentant une donnée associée */
export interface IIsiDtoAssociatedView extends IIsiDtoGridView  {
}
export class IsiDtoAssociatedView extends IsiDtoGridView implements IIsiDtoAssociatedView {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.AssociatedView.IsiDtoAssociatedView, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoAssociatedView) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoAssociatedView): IsiDtoAssociatedView {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAssociatedView();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
